import messages from "messages";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
// types
import type { DataTransferImportSource } from "../../../../types";
// styles
import styles from "./styles.module.scss";
// utils
import getClasses from "utils/getClasses";
import useToggleModal from "hooks/useToggleModal";
import DataTransferUploader from "../data-transfer-uploader";

type Props = {
  value: DataTransferImportSource;
};
/**
 * render a data transfer source
 */
const DataTransferSource = ({ value }: Props) => {
  const { show, open, close } = useToggleModal(false);

  return (
    <div className={styles["data-transfer-source"]}>
      {/* logo */}
      <div
        className={getClasses(
          styles["data-transfer-source__logo"],
          styles[`data-transfer-source__logo--${value.id}`],
        )}
      />
      <div className={styles["data-transfer-source__actions"]}>
        {/* import data */}
        <Button
          className={styles["data-transfer-source__import"]}
          variant={!value.disabled ? "primary" : "outline-primary"}
          disabled={value.disabled}
          onClick={open}
        >
          {messages.importData}
        </Button>
        {/* link */}
        <Button
          className={styles["data-transfer-source__url"]}
          variant={"link"}
          disabled={value.disabled}
          as={Link as any}
          target={"_blank"}
          to={value.disabled ? "#" : value.url}
          tabIndex={value.disabled ? -1 : undefined}
        >
          {messages.learnMore}
        </Button>
      </div>
      {!value.disabled && show && (
        <DataTransferUploader source={value.id} show={show} onHide={close} />
      )}
    </div>
  );
};

export default DataTransferSource;
